export interface SalaryUpdateItem {
	userId: string;
	newSalary: number | null;
}

export interface BulkUpdateError {
	userId: string;
	nif?: string;
	message: string;
}

export interface BulkUpdateResponse {
	successCount: number;
	failedCount: number;
	errors: BulkUpdateError[];
}

const bulkUpdateSalaries = async (
	token: string,
	companyId: string,
	updates: SalaryUpdateItem[]
): Promise<BulkUpdateResponse> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/salary-bulk-update/${companyId}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({ updates })
		}
	);

	if (!response.ok) {
		throw new Error('Failed to update salaries');
	}

	const json = await response.json();
	return json.data;
};

export default bulkUpdateSalaries;
